import { Box } from 'theme-ui';

import { useMenuDrawer } from './useMenuDrawer';
import { themed } from './MenuDrawer.theme';
import { MenuDrawer } from './MenuDrawer';

/**
 * Desktop menu drawer shell — hovered item sub items
 */
export const MenuDrawerShell = themed(({ theme, props }) => {
  const [{ hovered }, { unHoverDrawer, hoverDrawer }] = useMenuDrawer();

  return hovered?.secondaryMenu ? (
    <Box
      data-comp={MenuDrawerShell.displayName}
      as="aside"
      {...props}
      onMouseEnter={hoverDrawer}
      onMouseLeave={unHoverDrawer}
      sx={{
        ...theme.shell,
        ...(hovered ? theme.shell.open : theme.shell.closed),
      }}
    >
      <MenuDrawer hovered={hovered} />
    </Box>
  ) : null;
});

MenuDrawerShell.displayName = 'MenuDrawerShell';
